<template>
  <div :class="$style.base">
    <BaseButton
      color="inverted"
      :notification="orderCount"
      @click="close"
    >
      {{ $t('global.actions.proceed') }}
    </BaseButton>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useRegisterOrderStore } from '@/modules/register/stores/order';
import { useRegisterBrowserStore } from './store';

const { showMobileBrowser } = storeToRefs(useRegisterBrowserStore());
const { order } = useRegisterOrderStore();

const orderCount = computed(() =>
  order.items.reduce((sum, item) => sum + (item.quantity || 0), 0),
);

const router = useRouter();
const close = () => {
  showMobileBrowser.value = false;
  router.push({
    name: 'register-builder',
  });
};
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  padding: $spacing;
  background-color: var(--color-bg);
  box-shadow: var(--shadow);
}
</style>
